import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { setAccounts } from "../accountsSlice";
import { accountsNeedToFetchStatuses } from "../utils/constants/common";

export const getAccountsThunk = createAsyncThunk(
  "accounts/getAccounts",
  async (accountStatuses: string | void, { dispatch }) => {
    const statuses = accountStatuses ?? accountsNeedToFetchStatuses;

    try {
      const data = await dispatch(
        cloudChiprApi.endpoints.getUsersMeAccounts.initiate(
          { statuses },
          { forceRefetch: true },
        ),
      ).unwrap();

      data && dispatch(setAccounts(data));
    } catch (e: any) {
      const status = String(e?.status ?? "");

      if (status.startsWith("5")) {
        window.history.pushState(null, "", "/accounts-issue");
        window.dispatchEvent(new PopStateEvent("popstate"));
      }
    }
  },
);
